module.exports = __webpack_public_path__ + "static/media/cesura-11.4767c17b.jpg";